(function ($) {
    if ($('.page-template-template-homes').length) {

        if (window.location.hash) {
            $(`.page-nav li[data-tab="${window.location.hash.split("#")[1]}"]`).addClass('active').siblings().removeClass('active');
            $('.page-tab').removeClass('active').filter(`[data-tab="${window.location.hash.split("#")[1]}"]`).addClass('active');
        }

        if (window.location.hash.split("#")[1] === "homes") {
            $('.homes-search').addClass('white-bg');
            $('.mobile-filter-triggers').addClass('active');
        }


        // Homes table search

        $('.project-block .button-show-more').on('click', function() {
            $(this).parent().find('tbody tr').addClass('visible');
            $(this).parent().find('tbody tr').removeClass('hide');
            $(this).parent().find('.apartments-table-mobile .apartment').addClass('visible');
            $(this).hide();
        })

        // Page tabs navigation

        $('.homes-search .page-nav li').on('click', function () {
            $('.mobile-filter-triggers').removeClass('active');
            if ($(this).hasClass('active')) return;
            $(this).addClass('active').siblings().removeClass('active');
            window.history.pushState('', '/', `#${$(this).data('tab')}`)
            $('.homes-search .page-tab').removeClass('active').filter(`[data-tab="${$(this).data('tab')}"]`).addClass('active');

            if ($(this).data('tab') === "homes") {
                $('.homes-search').addClass('white-bg');
                $('.mobile-filter-triggers').addClass('active');
            } else {
                $('.homes-search').removeClass('white-bg');
            }
        });

        $('.homes-page-nav-mobile .navigation-header').on('click', function () {
            const parent = $(this).closest('.homes-page-nav-mobile');
            const nav = parent.find('ul');

            parent.toggleClass('active');
            nav.slideToggle();
        });

        $('.homes-page-nav-mobile li').on('click', function () {
            if ($(this).hasClass('active')) return;

            window.history.pushState('', '/', `#${$(this).data('tab')}`)

            if ($(this).data('tab') === "homes") {
                $('.homes-search').addClass('white-bg');
            } else {
                $('.homes-search').removeClass('white-bg');
            }

            const tabName = $(this).text();
            const parent = $(this).closest('.homes-page-nav-mobile');
            $(parent).find('ul').slideToggle();
            parent.toggleClass('active');
            $(parent).find('.navigation-header p').text(tabName);
            $(this).addClass('active').siblings().removeClass('active');
            $('.homes-search .page-tab').removeClass('active').filter(`[data-tab="${$(this).data('tab')}"]`).addClass('active');
        });

        $('.toggle-list-mobile .header').on('click', function () {
            const parent = $(this).closest('.toggle-list-mobile');
            const nav = parent.find('ul');

            parent.toggleClass('active');
            nav.slideToggle();
        });

        $('.toggle-list-mobile li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const parent = $(this).closest('.toggle-list-mobile');
            const tabName = $(this).text();
            const nav = $(parent).find('ul');
            const status = $(this).data('status');

            $(this).addClass('active').siblings().removeClass('active');
            parent.toggleClass('active');
            nav.slideToggle();
            parent.find('.header p').text(tabName);

            if (status === "all") {
                $('.homes-grid').empty().append(clone)
            } else {
                $('.homes-grid').empty().append(clone.filter(`[data-status="${status}"]`))
            }
        });

        const clone = $('.homes-grid .home');

        $('.homes-search .toggle-list li').on('click', function () {
            if ($(this).hasClass('active')) return;

            const status = $(this).data('status');
            $(this).addClass('active').siblings().removeClass('active');

            if (status === "all") {
                $('.homes-grid').empty().append(clone)
            } else {
                $('.homes-grid').empty().append(clone.filter(`[data-status="${status}"]`))
            }
        })
    }
})(jQuery);